var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.886,
    height: 20.431,
    viewBox: "0 0 22.886 20.431",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.297 0.269)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M22.1,35.662,11.511,27.91a.58.58,0,0,0-.686,0L.237,35.662a.58.58,0,1,0,.686.937l10.246-7.5,10.246,7.5a.58.58,0,0,0,.686-.937Z",
    transform: "translate(0.001 -27.797)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.463 8.933)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M73.284,232.543a.58.58,0,0,0-.58.58v9.238H68.06v-5.043a2.9,2.9,0,1,0-5.8,0v5.043H57.613v-9.238a.58.58,0,1,0-1.161,0v9.819a.58.58,0,0,0,.58.58h5.8a.58.58,0,0,0,.578-.535.435.435,0,0,0,0-.045v-5.623a1.741,1.741,0,1,1,3.483,0v5.623a.426.426,0,0,0,0,.045.58.58,0,0,0,.578.536h5.8a.58.58,0,0,0,.58-.58v-9.819A.58.58,0,0,0,73.284,232.543Z",
    transform: "translate(-56.452 -232.543)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.895e44db.svg";
export { ForwardRef as ReactComponent };